export type FormatNbsNumberOptions = {
  /** Maximum fraction digits (default 2). */
  readonly decimals?: number;
  /** BCP 47 locale (default `fr-FR`). */
  readonly locale?: string;
  /** Placeholder when value is nullish / non-finite (default `—`). */
  readonly empty?: string;
};

/**
 * Canonical numeric display for NBS surfaces.
 * Caps floating-point noise (`33.666666…` → `33,67`) while keeping integers clean.
 */
export function formatNbsNumber(
  value: number | string | null | undefined,
  options: FormatNbsNumberOptions = {},
): string {
  const empty = options.empty ?? "—";
  if (value == null || value === "") return empty;

  const num = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(num)) return empty;

  const decimals = options.decimals ?? 2;
  const locale = options.locale ?? "fr-FR";

  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: decimals,
    minimumFractionDigits: 0,
  }).format(num);
}
